import _ from 'lodash';
import Backbone from 'backbone';

const PropertyModel = Backbone.Model.extend({
    idAttribute: 'uuid',
    url: '/api/property',
    defaults: {
        name: '',
        url: '',
        imageUrl: '',
        type: 'SbgStation',
        brandUuid: '',
    },
    initialize: function initialize() {
        this.idAttribute = 'uuid';
    },
    parse(data) {
        const model = data && (_.isArray(data.data) && data.data.length > 0) ? data.data[0] : data;
        if (model && model.response) {
            delete model.response;
        }
        return model;
    },

    getModelId: function getModelId() {
        return this.attributes.uuid;
    },
});
export default PropertyModel;
